// extracted by mini-css-extract-plugin
export default {"target_product":"Raa","retake":"Saa","product_info":"Taa","icon":"Uaa","target_image":"Vaa","background":"Waa","product_info_desktop":"Xaa","info":"Yaa","title":"Zaa","benefits":"aba","benefit":"bba","accordeon_wrapper":"cba","ingredients_wrapper":"eba","info_wrapper":"fba","product_wrapper":"gba"};
    if(module.hot) {
      // 1730991513062
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  